/* global store */
import gsap from 'gsap';
import { callVPAID, vpaidPresent } from 'Renderer/utils/vpaid';

export const syncTimeline = (v) => {
  const { activeArtboard, rootElement, timelines, targetComponentTimelines } = store.getState();
  const timeline = timelines[activeArtboard.key];
  const componentTimelines = targetComponentTimelines[activeArtboard.key];
  const vpaid = vpaidPresent() ? callVPAID() : null;

  const updateTimeline = () => {
    timeline.seek(v.currentTime);
    const groupElements = rootElement.querySelectorAll('div[data-group]:not([data-autohide="true"])');
    [...groupElements].forEach((elem) => {
      if (componentTimelines[elem.id]) componentTimelines[elem.id].seek(v.currentTime);
    });
  };

  v.addEventListener('play', () => {
    gsap.ticker.add(updateTimeline);
    if (vpaid) vpaid.resumeAd();
  });
  v.addEventListener('pause', () => {
    gsap.ticker.remove(updateTimeline);
    if (vpaid) vpaid.pauseAd();
  });
};



// WEBPACK FOOTER //
// ./app/javascript/renderer/domOperations/syncOperations.js